import "./index.scss";
import { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import startIcon from "../../assets/开始核查.svg";
import timingIcon from "../../assets/闹钟.svg";
import {
  PlusOutlined,
  LeftOutlined,
  EditOutlined,
  DeleteOutlined,
  FileSearchOutlined,
  PlayCircleOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import icon2 from "../../assets/02.svg";
import icon1 from "../../assets/01.svg";
import {
  Tooltip,
  message,
  Typography,
  Select,
  DatePicker,
  Input,
  Table,
  Pagination,
  Empty,
} from "antd";
import Api from "../../apis/index";
import { useDebounce, useGetState, useSize, useUnmount } from "ahooks";
import dayjs from "dayjs";
import { debounce, guid } from "../../unit/unit";
import CreateDrawer from "./components/CreateDrawer";
import StatusTag from "../../components/StatusTag/index";
import { timerInterval } from "../../setting";
import MessageModal from "../../components/MessageModal/index";
import emptyImg from "../../assets/暂无icon.png";
const { Paragraph } = Typography;
const { RangePicker } = DatePicker;

function Home() {
  const carouselRef = useRef(null);
  const carouselRef2 = useRef(null);
  const timer = useRef();
  const contentRef = useRef(null);
  const size = useSize(contentRef);
  const carouselSize = useSize(carouselRef2);

  const bgColor = ["#829DFF", "#C88EED", "#FF9E82", "#00A5AF"];

  const [notHasPrev, setNotHasPrev] = useState(true);
  const [notHasNext, setNotHasNext] = useState(false);
  const [reportTypeList, setReportTypeList] = useState([]);

  const [data, setData, getData] = useGetState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber, getPageNumber] = useGetState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const [verifyStatus, setVerifyStatus, getVerifyStatus] = useGetState(null);
  const [verifyType, setVerifyType, getVerifyType] = useGetState(null);
  const [verifyTime, setVerifyTime, getVerifyTime] = useGetState([]);
  const [verifyObject, setVerifyObject, getVerifyObject] = useGetState(null);
  const [verifyTypeOptions, setVerifyTypeOptions] = useState([]);
  const [verifyStatusOptions, setVerifyStatusOptions] = useState([]);
  const debouncedVerifyObject = useDebounce(verifyObject, { wait: 200 });

  const [orderField, setOrderField, getOrderField] = useGetState("create_time"); //排序字段
  const [orderAsc, setOrderAsc, getOrderAsc] = useGetState(-1); //排序顺序：1升序/-1降序

  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);
  const [isScheduledTask, setIsScheduledTask] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [
    isScheduledTasksView,
    setIsScheduledTasksView,
    getIsScheduledTasksView,
  ] = useGetState(false);

  const [verifySetting, setVerifySetting] = useState(null);

  useEffect(() => {
    setVerifyStatus(null);
    setVerifyType(null);
    setVerifyTime([]);
    setVerifyObject(null);
    if (isScheduledTasksView) {
    }
  }, [isScheduledTasksView]);

  //删除
  const deleteFunc = (itemInfo) => {
    let task_ids = [];
    if (itemInfo) {
      task_ids.push(itemInfo?.id);
    } else {
      task_ids = selectedRowKeys;
    }
    if (task_ids.length === 0) {
      message.warning("请选择要删除的记录");
      return;
    }
    let api = getIsScheduledTasksView()
      ? Api.deleteCronVerify
      : Api.deleteVerify;
    api(task_ids).then((res) => {
      if (res.code === 200) {
        message.success(res.message);
        if (getIsScheduledTasksView()) {
          getScheduledTaskData();
        } else {
          getDataFunc();
        }
      } else {
        message.error(res.message);
      }
    });
  };

  //操作核查记录
  const verificationTaskHandle = (type, itemInfo, isScheduledTask = false) => {
    let isScheduledTasksView = getIsScheduledTasksView();
    if (type === "查看") {
      if (isScheduledTasksView) {
        setSelectedRowKeys((prev) => {
          if (prev.includes(itemInfo.id)) {
            return prev.filter((i) => i !== itemInfo.id);
          } else {
            return [itemInfo.id, ...prev];
          }
        });
        return;
      }
      window.open(
        window.location.origin + `/taskDetails/${itemInfo.id}`,
        guid(),
      );
      return;
    }
    if (type === "设置为定时任务") {
      setIsScheduledTask(true);
      type = "再次核查";
    }
    if (type === "再次核查") {
      if (isScheduledTask) {
        setIsScheduledTask(true);
      } else {
        setIsScheduledTask(isScheduledTasksView);
      }
      Api.getCheckSettingInfo({
        data_id: itemInfo.id,
        is_cron: isScheduledTasksView ? 1 : null,
      }).then((res) => {
        if (res.code === 200) {
          let obj = { ...res.data };
          if (!isScheduledTask) {
            obj.id = itemInfo.id;
          }
          setVerifySetting(obj || null);
          setCreateDrawerOpen(true);
        } else {
          message.error(res.message);
        }
      });
      return;
    }
    if (type === "启动") {
      console.log(itemInfo);
      Api.getReportStatus(itemInfo.id).then((res) => {
        if (res.code === 200) {
          let text = '确定要启动此任务吗？';
          //报告正在生成
          if (res.data === 1) {
            text = '报告正在生成中，确定要重启此任务吗？';
          }
          MessageModal({
            type: "info",
            description: text,
            title: type,
            onOk: () => {
              Api.handleTask(itemInfo.id, 10).then((res) => {
                if (res.code === 200) {
                  setDataTimeout();
                  message.success(res.message);
                } else {
                  message.error(res.message);
                }
              });
            },
          });
        } else {
          message.error(res.message);
        }
      });
      return;
    }
    MessageModal({
      type: "info",
      description: `确定要${type}此条数据吗？`,
      title: type,
      onOk: () => {
        const status = type === "终止" ? 40 : 10;
        Api.handleTask(itemInfo.id, status).then((res) => {
          if (res.code === 200) {
            setDataTimeout();
            message.success(res.message);
          } else {
            message.error(res.message);
          }
        });
      },
    });
  };

  const columns = useRef([
    {
      title: "序号",
      dataIndex: "index",
      align: "center",
      width: 60,
      render: (_, __, index) =>
        getPageNumber() * pageSize - pageSize + index + 1,
    },
    {
      title: "核查类型",
      dataIndex: "type_name",
      align: "center",
      width: 100,
    },
    {
      title: "核查对象",
      dataIndex: "check_obj",
      align: "center",
      render: (_) => (
        <Paragraph ellipsis={{ rows: 3, tooltip: _ }}>{_}</Paragraph>
      ),
    },
    {
      title: "核查时间",
      dataIndex: "create_time",
      align: "center",
      // width: 180,
    },
    {
      title: "核查状态",
      dataIndex: "status_name",
      align: "center",
      width: 130,
      render: (_, record) => (
        <StatusTag
          key={_}
          data={record}
          progress={record?.task_process?.progress_percent}
        ></StatusTag>
      ),
    },
    {
      title: "核查网站数",
      dataIndex: "check_web_count",
      align: "center",
      width: 120,
    },
    {
      title: "核查结果",
      dataIndex: "check_res",
      align: "center",
      width: 160,
      render: (_, record) => {
        if (JSON.stringify(record?.check_res) === "{}") {
          return "-";
        }
        return (
          <>
            <div className="check_res_div">
              <div>
                <span
                  className={
                    record.check_res?.abnormal_count
                      ? "check_res_span"
                      : "check_res_span2"
                  }
                >
                  {record.check_res?.abnormal_count || 0}
                </span>
                个网站关注项
              </div>
              {record.check_res?.failed_count ? (
                <div>
                  <span>{record.check_res?.failed_count || 0}</span>
                  个网站核查失败
                </div>
              ) : null}
            </div>
          </>
        );
      },
    },
    {
      title: "核查人",
      dataIndex: "show_name",
      align: "center",
      width: 100,
    },
    {
      title: "操作",
      dataIndex: "操作",
      width: 120,
      render: (_, record) => (
        <span
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="tableIconsContent"
        >
          {
            <Tooltip title="查看">
              <FileSearchOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  verificationTaskHandle("查看", record);
                }}
              />
            </Tooltip>
          }
          {(record.status === 30 || record.status === 50) && (
            <Tooltip title="再次核查">
              <RedoOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  verificationTaskHandle("再次核查", record);
                }}
                style={{ marginLeft: "4px" }}
              />
            </Tooltip>
          )}
          {
            <Tooltip title="设置为定时任务">
              <svg
                t="1757899832288"
                className="iconItem"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2819"
                width="16"
                height="16"
                onClick={(e) => {
                  e.stopPropagation();
                  verificationTaskHandle("再次核查", record, true);
                }}
              >
                <path
                  d="M898.3 530.6c-0.6 58.9-12.6 115.2-38.5 168.4-17.7 36.5-40.2 69.6-68.2 98.9-2 2.1-3.9 4.4-6.1 6.5-1.6 1.5-1.3 2.6 0.1 4.2 20.2 22.7 40.3 45.5 60.5 68.3 9.2 10.4 18.4 20.7 27.5 31.1 10.5 12 12.2 28.4 4.4 41.6-7.9 13.4-22.9 20.1-38.3 16.8-7.2-1.5-13.5-5-18.5-10.6-20.6-23.3-41.2-46.6-61.8-70-9.2-10.5-18.5-20.9-27.7-31.4-2.2-2.5-3.8-2.1-6.3-0.5-31.6 21.1-65.4 37.5-101.8 48.8-23.8 7.4-48.1 12.2-72.9 14.9-14.9 1.6-29.9 2.6-44.9 2.4-37.2-0.5-73.8-5.6-109.5-16.3-38.8-11.7-74.9-29.2-108.3-52-2.1-1.4-3-0.7-4.4 0.8-11.9 13.5-23.8 26.9-35.8 40.4-13.6 15.4-27.2 30.9-40.9 46.3-4.4 5-8.9 9.8-13.2 14.9-14 16.3-35.8 17.8-52 3.6-14.1-12.5-14.6-35.2-1.4-50.1 29.5-33.2 59-66.6 88.5-99.9 2-2.3 1.9-3.7-0.2-5.9-54.9-57.1-89.8-124.5-104.1-202.5-5.2-28.5-7.1-57.3-5.7-86.2 3.8-81.5 30.5-154.8 79.9-219.6 33.9-44.5 75.7-79.9 125-106.4 42.4-22.8 87.3-37.3 135.1-43.2 17.2-2.1 34.4-3.5 51.6-3.2 58 0.8 113.6 12.8 166 38.2 35.8 17.4 68.5 39.3 97.5 66.6C836.5 303.8 875.7 375 891.7 459c3.4 17.8 5.3 35.8 6 53.9 0.3 5.8 0.6 11.8 0.6 17.7zM508.2 849.1c16 0 31.9-1.3 47.7-3.6 38-5.5 73.4-18.5 107.4-36.3 21.5-11.3 38.6-28.2 58.2-41.8 0.3-0.2 0.5-0.5 0.8-0.7 9.5-8.6 18.4-17.7 26.8-27.4 21.4-24.5 38.6-51.8 51.6-81.5 19.2-43.7 27.8-89.5 26.4-137.1-0.6-20.8-3-41.3-7.8-61.5-14.9-63.9-46.5-118.2-94.5-163-21.5-20.1-45.5-36.6-71.6-50.1-40.6-20.9-83.8-32.1-129.3-34.4-25-1.2-49.9 0.3-74.5 5.2-75.8 14.8-138.6 52.1-187.6 111.7-45.6 55.5-69.2 119.7-72 191.5-0.8 21.3 0.8 42.6 4.4 63.6 10.8 62.4 37.9 116.9 80.8 163.5 25.6 27.8 55.4 50.1 89 67.3 45.3 23 93.4 34.3 144.2 34.6zM712.7 57.7c5.5 0 10.5 1.5 15.4 3.7 45.6 20.8 87.4 47.6 125.3 80.5 52 45.3 93.2 98.8 124 160.5 12.5 25.1 22.9 51.2 30.9 78.1 6.6 22.3-9.9 44.9-33.1 45.5-14.3 0.4-28.1-8.4-33.2-21.8-5-13-8.9-26.5-14.1-39.4C909 318.2 883.1 276 850 238.1c-38-43.3-82.7-78-134-104.1-5.7-2.9-11.5-5.6-17.3-8.3-14.3-6.6-22.9-21.2-21.2-36.1 1.9-16.2 13.1-28.2 29.4-31.3 1.8-0.4 3.8-0.4 5.8-0.6zM312.3 57.8c16.4 0.1 30.7 11.7 34.2 27.7 3.5 16.2-4.6 32.9-19.7 39.7-39.2 17.7-75.2 40.5-107.7 68.6-40.2 34.8-73.3 75.4-99.1 121.9-15 27-26.7 55.4-36 84.8-4.5 14.3-14.6 22.6-29.4 24.8-18.1 2.7-35.7-10.2-39.2-28.3-1.1-6-0.7-11.7 1.1-17.5C31.7 330.1 53.8 283.8 83 241c19.7-28.8 41.9-55.5 67-79.8 34.8-33.7 73.5-62.1 116.3-84.9 9.6-5.1 19.4-9.9 29.2-14.5 5.3-2.5 10.8-4.2 16.8-4z"
                  p-id="2820"
                  fill="currentColor"
                ></path>
                <path
                  d="M474.1 460.1c0-24-0.2-48 0.1-72.1 0.1-17.1 12-31 28.5-34.1 21.8-4.1 41.7 11.7 42 34 0.3 18.1 0.1 36.2 0.1 54.3v48.3c0 5 0 5 5.2 5h87.7c7.6 0 15.1 0.7 22 4.4 13.4 7.1 20.5 21.9 17.8 37.8-2.4 14.3-14.7 26.2-29.2 28.2-3.5 0.5-7.1 0.6-10.6 0.6H511.3c-22.1 0-37.2-15.1-37.3-37.3v-0.7c0-22.8 0-45.6 0.1-68.4-0.1 0 0 0 0 0z"
                  p-id="2821"
                  fill="currentColor"
                ></path>
              </svg>
            </Tooltip>
          }
          {record.status === 40 && (
            <Tooltip title="启动">
              <PlayCircleOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  verificationTaskHandle("启动", record);
                }}
                style={{ marginLeft: "4px" }}
              />
            </Tooltip>
          )}
          {(record.status === 20 || record.status === 10) && (
            <Tooltip title="终止">
              <svg
                onClick={(e) => {
                  e.stopPropagation();
                  verificationTaskHandle("终止", record);
                }}
                style={{ marginLeft: "4px" }}
                t="1757403051877"
                viewBox="0 0 1024 1024"
                version="1.1"
                p-id="4592"
                width="18"
                height="18"
              >
                <path
                  d="M512 928A416 416 0 1 1 928 512 416 416 0 0 1 512 928z m0-768A352 352 0 1 0 864 512 352 352 0 0 0 512 160z m96 512h-192a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64h192a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64z"
                  fill="#333333"
                  p-id="4593"
                ></path>
              </svg>
            </Tooltip>
          )}
          {(record.status === 30 ||
            record.status === 40 ||
            record.status === 50) && (
            <Tooltip title="删除">
              <svg
                className="tableIcon"
                fill="none"
                version="1.1"
                width="15.14990234375"
                height="16.14990234375"
                viewBox="0 0 15.14990234375 16.14990234375"
                style={{ marginLeft: "4px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  MessageModal({
                    type: "warning",
                    description: "确定要删除此条数据吗？",
                    title: "删除",
                    onOk: () => {
                      deleteFunc(record);
                    },
                  });
                }}
              >
                <g>
                  <g>
                    <path
                      d="M9.847077466125487,13.534786463165283L9.847077466125487,5.638324463165283C9.847077466125487,5.352412463165283,9.619367466125489,5.120636463165283,9.338487466125489,5.120636463165283C9.057597466125488,5.120636463165283,8.829897466125487,5.352412463165283,8.829897466125487,5.638324463165283L8.829897466125487,13.534786463165283C8.829897466125487,13.820696463165284,9.057597466125488,14.052476463165283,9.338487466125489,14.052476463165283C9.619367466125489,14.052476463165283,9.847077466125487,13.820696463165284,9.847077466125487,13.534786463165283ZM6.273387466125488,13.534786463165283L6.273387466125488,5.638324463165283C6.273387466125488,5.352412463165283,6.045683466125488,5.120636463165283,5.764797466125488,5.120636463165283C5.483910466125488,5.120636463165283,5.256207466125488,5.352412463165283,5.256207466125488,5.638324463165283L5.256207466125488,13.534786463165283C5.256207466125488,13.820696463165284,5.483910466125488,14.052476463165283,5.764797466125488,14.052476463165283C6.045683466125488,14.052476463165283,6.273387466125488,13.820696463165284,6.273387466125488,13.534786463165283Z"
                      fill="currentColor"
                      fill-opacity="1"
                    />
                    <path
                      d="M5.351668966125488,13.953406463165283Q5.522675466125488,14.127476463165284,5.764797466125488,14.127476463165284Q6.006918466125488,14.127476463165284,6.1779254661254885,13.953406463165283Q6.348387466125488,13.779896463165283,6.348387466125488,13.534786463165283L6.348387466125488,5.638324463165283Q6.348387466125488,5.393213463165283,6.1779254661254885,5.219702763165283Q6.006917466125488,5.045636463165283,5.764797466125488,5.045636463165283Q5.522676466125488,5.045636463165283,5.3516687661254885,5.219702763165283Q5.181207466125488,5.393213463165283,5.181207466125488,5.638324463165283L5.181207466125488,13.534786463165283Q5.181207466125488,13.779896463165283,5.351668966125488,13.953406463165283ZM8.925357466125488,13.953406463165283Q9.09636746612549,14.127476463165284,9.338487466125489,14.127476463165284Q9.580607466125489,14.127466463165284,9.751617466125488,13.953406463165283Q9.922077466125488,13.779896463165283,9.922077466125488,13.534786463165283L9.922077466125488,5.638324463165283Q9.922077466125488,5.393212463165283,9.751617466125488,5.219702763165283Q9.580607466125489,5.045636463165283,9.338487466125489,5.045636463165283Q9.09636746612549,5.045636463165283,8.925357466125488,5.219702763165283Q8.754897466125488,5.393213463165283,8.754897466125488,5.638324463165283L8.754897466125488,13.534786463165283Q8.754897466125488,13.779896463165283,8.925357466125488,13.953406463165283ZM6.070923466125488,13.848286463165284Q5.944005466125488,13.977476463165283,5.764797466125488,13.977476463165283Q5.585588466125488,13.977476463165283,5.458670466125488,13.848286463165284Q5.3312074661254885,13.718536463165282,5.3312074661254885,13.534786463165283L5.3312074661254885,5.638324463165283Q5.3312074661254885,5.454568463165283,5.458670466125488,5.3248244631652835Q5.585588466125488,5.195636463165283,5.764797466125488,5.195636463165283Q5.944005466125488,5.195636463165283,6.070923466125488,5.3248244631652835Q6.198386466125489,5.454568463165283,6.198386466125489,5.638324463165283L6.198386466125489,13.534786463165283Q6.198386466125489,13.718536463165282,6.070923466125488,13.848286463165284ZM9.644607466125489,13.848286463165284Q9.517697466125489,13.977476463165283,9.338487466125489,13.977476463165283Q9.159277466125488,13.977476463165283,9.032357466125488,13.848286463165284Q8.904897466125488,13.718546463165284,8.904897466125488,13.534786463165283L8.904897466125488,5.638323463165284Q8.904897466125488,5.454568463165283,9.032357466125488,5.3248244631652835Q9.159277466125488,5.195636463165283,9.338487466125489,5.195636463165283Q9.517697466125489,5.195636463165283,9.644607466125489,5.3248244631652835Q9.772077466125488,5.454567463165283,9.772077466125488,5.638324463165283L9.772077466125488,13.534786463165283Q9.772077466125488,13.718546463165284,9.644607466125489,13.848286463165284Z"
                      fill-rule="evenodd"
                      fill="currentColor"
                      fill-opacity="1"
                    />
                  </g>
                  <g>
                    <path
                      d="M6.442491171875,1.110331171875L8.714191171875,1.110331171875C8.995081171875,1.110331171875,9.222781171875,0.878550171875,9.222781171875,0.592639171875C9.222781171875,0.306728171875,8.995081171875,0.0749511323786,8.714191171875,0.074951171875L6.442491171875,0.074951171875C6.161601171875,0.0749511323786,5.933901171875,0.306728171875,5.933901171875,0.592639171875C5.933901171875,0.878550171875,6.161601171875,1.110331171875,6.442491171875,1.110331171875ZM14.566351171875,1.911021171875L0.583541171875,1.911021171875C0.302654171875,1.911021171875,0.074951171875,2.142791171875,0.074951171875,2.428701171875C0.074951171875,2.714611171875,0.302654171875,2.946391171875,0.583541171875,2.946391171875L14.566351171875,2.946391171875C14.847251171875,2.946391171875,15.074951171875,2.714611171875,15.074951171875,2.428701171875C15.074951171875,2.142791171875,14.847251171875,1.911021171875,14.566351171875,1.911021171875M13.210151171875,3.912741171875C12.929251171875,3.912741171875,12.701551171875,4.144521171875,12.701551171875,4.430431171875L12.701551171875,15.039551171875L2.448371171875,15.039551171875L2.448371171875,4.430431171875C2.448371171875,4.144521171875,2.220661171875,3.912741171875,1.939781171875,3.912741171875C1.658891171875,3.912741171875,1.431191171875,4.144521171875,1.431191171875,4.430431171875L1.431191171875,15.557251171875C1.431191171875,15.843151171875,1.658891171875,16.074951171875,1.939781171875,16.074951171875L13.210151171875,16.074951171875C13.491051171875,16.074951171875,13.718751171875,15.843151171875,13.718751171875,15.557251171875L13.718751171875,4.430431171875C13.718751171875,4.144521171875,13.491051171875,3.912741171875,13.210151171875,3.912741171875Z"
                      fill="currentColor"
                      fill-opacity="1"
                    />
                    <path
                      d="M6.029361171875,0.174017571875Q5.858901171875,0.347528171875,5.858901171875,0.592639171875Q5.858901171875,0.837749171875,6.029361171875,1.011260171875Q6.200371171875,1.185331171875,6.442491171875,1.185331171875L8.714191171875,1.185331171875Q8.956311171875,1.185331171875,9.127321171875,1.011260171875Q9.297781171875,0.837748171875,9.297781171875,0.592639171875Q9.297781171875,0.347529171875,9.127321171875,0.174017571875Q8.956311171875,-0.000048828124999997224,8.714191171875,-0.000048828124999997224L6.442491171875,-0.000048828124999997224Q6.200371171875,-0.000048828124999997224,6.029361171875,0.174017571875ZM6.136371171875,0.906138171875Q6.008901171875,0.776395171875,6.008901171875,0.592639171875Q6.008901171875,0.408883171875,6.136371171875,0.27913917187500004Q6.263281171875,0.149951171875,6.442491171875,0.149951171875L8.714191171875,0.149951171875Q8.893401171875,0.149951171875,9.020321171875,0.27913917187500004Q9.147781171875,0.408884171875,9.147781171875,0.592639171875Q9.147781171875,0.776394171875,9.020321171875,0.906138171875Q8.893401171875,1.0353271718750001,8.714191171875,1.035326171875L6.442491171875,1.0353271718750001Q6.263281171875,1.0353271718750001,6.136371171875,0.906138171875ZM14.979451171875,2.010081171875Q14.808451171875,1.836021171875,14.566351171875,1.836021171875L0.583540171875,1.836021171875Q0.341419171875,1.836021171875,0.170412471875,2.010081171875Q-0.000048828124999997224,2.183591171875,-0.000048828124999997224,2.428701171875Q-0.000048828124999997224,2.673811171875,0.170412571875,2.847331171875Q0.341420171875,3.021391171875,0.583541171875,3.021391171875L14.566351171875,3.021391171875Q14.808451171875,3.021391171875,14.979451171875,2.847331171875Q15.149951171875,2.673811171875,15.149951171875,2.428701171875Q15.149951171875,2.183601171875,14.979451171875,2.010081171875ZM0.583541171875,1.986021171875L14.566351171875,1.986021171875Q14.745551171875,1.986021171875,14.872451171875,2.115201171875Q14.999951171875,2.244951171875,14.999951171875,2.428701171875Q14.999951171875,2.612461171875,14.872451171875,2.742201171875Q14.745551171875,2.871391171875,14.566351171875,2.871391171875L0.583541171875,2.871391171875Q0.404332171875,2.871391171875,0.277414171875,2.742201171875Q0.149951171875,2.612461171875,0.149951171875,2.428701171875Q0.149951171875,2.244951171875,0.277414171875,2.115201171875Q0.404332171875,1.986021171875,0.583541171875,1.986021171875ZM13.793751171875,15.557251171875L13.793751171875,4.430431171875Q13.793751171875,4.185321171875,13.623251171875,4.011811171874999Q13.452251171875,3.837741171875,13.210151171875,3.837741171875Q12.968051171875,3.837741171875,12.796951171875,4.011811171874999Q12.626551171875,4.185321171875,12.626551171875,4.430431171875L12.626551171875,14.964551171875L2.523371171875,14.964551171875L2.523371171875,4.430431171875Q2.523371171875,4.185321171875,2.352911171875,4.011811171874999Q2.181901171875,3.837741171875,1.939781171875,3.837741171875Q1.697661171875,3.837741171875,1.526651171875,4.011811171874999Q1.356191171875,4.185321171875,1.356191171875,4.430431171875L1.356191171875,15.557251171875Q1.356191171875,15.802351171875,1.526651171875,15.975851171875Q1.697661171875,16.149951171875,1.939781171875,16.149951171875L13.210151171875,16.149951171875Q13.452251171875,16.149951171875,13.623251171875,15.975851171875Q13.793751171875,15.802351171875,13.793751171875,15.557251171875ZM13.516251171875,4.116931171875Q13.643751171875,4.246671171875,13.643751171875,4.430431171875L13.643751171875,15.557251171875Q13.643751171875,15.741051171875,13.516251171875,15.870751171875Q13.389351171875,15.999951171875,13.210151171875,15.999951171875L1.939781171875,15.999951171875Q1.760571171875,15.999951171875,1.633651171875,15.870751171875Q1.506191171875,15.741051171875,1.506191171875,15.557251171875L1.506191171875,4.430431171875Q1.506191171875,4.246671171875,1.633651171875,4.116931171875Q1.760571171875,3.987741171875,1.939781171875,3.987741171875Q2.118991171875,3.987741171875,2.245901171875,4.116931171875Q2.373371171875,4.246671171875,2.373371171875,4.430431171875L2.373371171875,15.114551171875L12.776551171875,15.114551171875L12.776551171875,4.430431171875Q12.776551171875,4.246671171875,12.903951171875,4.116931171875Q13.030951171875,3.987741171875,13.210151171875,3.987741171875Q13.389351171875,3.987741171875,13.516251171875,4.116931171875Z"
                      fill-rule="evenodd"
                      fill="currentColor"
                      fill-opacity="1"
                    />
                  </g>
                </g>
              </svg>
            </Tooltip>
          )}
        </span>
      ),
    },
  ]);
  const columns2 = useRef([
    {
      title: "序号",
      dataIndex: "index",
      align: "center",
      width: 60,
      render: (_, __, index) =>
        getPageNumber() * pageSize - pageSize + index + 1,
    },
    {
      title: "核查对象",
      dataIndex: "check_obj",
      align: "center",
      render: (_) => (
        <Paragraph ellipsis={{ rows: 3, tooltip: _ }}>{_}</Paragraph>
      ),
    },
    {
      title: "任务类型",
      dataIndex: "type_name",
      align: "center",
      width: 120,
    },
    {
      title: "核查时间",
      dataIndex: "cron_time",
      align: "center",
      width: 160,
      render: (_, record) => <span>{_}</span>,
    },
    {
      title: "任务状态",
      dataIndex: "status_name",
      align: "center",
      width: 100,
    },
    {
      title: "核查网站数",
      dataIndex: "check_web_count",
      align: "center",
      width: 120,
    },
    {
      title: "上次执行时间",
      dataIndex: "last_run_time",
      align: "center",
      // width: 160,
    },
    {
      title: "任务创建时间",
      dataIndex: "create_time",
      align: "center",
      // width: 160,
    },
    {
      title: "操作",
      dataIndex: "操作",
      width: 100,
      render: (_, record) => (
        <span
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="tableIconsContent"
        >
          {/* <Tooltip title="查看">
            <FileSearchOutlined
              onClick={(e) => {
                e.stopPropagation();
                verificationTaskHandle("查看", record);
              }}
            />
          </Tooltip> */}

          <Tooltip title="修改">
            <EditOutlined
              onClick={(e) => {
                e.stopPropagation();
                verificationTaskHandle("再次核查", record);
              }}
              style={{ marginLeft: "4px" }}
            />
          </Tooltip>

          <Tooltip title="删除">
            <svg
              className="tableIcon"
              fill="none"
              version="1.1"
              width="15.14990234375"
              height="16.14990234375"
              viewBox="0 0 15.14990234375 16.14990234375"
              style={{ marginLeft: "4px" }}
              onClick={(e) => {
                e.stopPropagation();
                MessageModal({
                  type: "warning",
                  description: "确定要删除此条数据吗？",
                  title: "删除",
                  onOk: () => {
                    deleteFunc(record);
                  },
                });
              }}
            >
              <g>
                <g>
                  <path
                    d="M9.847077466125487,13.534786463165283L9.847077466125487,5.638324463165283C9.847077466125487,5.352412463165283,9.619367466125489,5.120636463165283,9.338487466125489,5.120636463165283C9.057597466125488,5.120636463165283,8.829897466125487,5.352412463165283,8.829897466125487,5.638324463165283L8.829897466125487,13.534786463165283C8.829897466125487,13.820696463165284,9.057597466125488,14.052476463165283,9.338487466125489,14.052476463165283C9.619367466125489,14.052476463165283,9.847077466125487,13.820696463165284,9.847077466125487,13.534786463165283ZM6.273387466125488,13.534786463165283L6.273387466125488,5.638324463165283C6.273387466125488,5.352412463165283,6.045683466125488,5.120636463165283,5.764797466125488,5.120636463165283C5.483910466125488,5.120636463165283,5.256207466125488,5.352412463165283,5.256207466125488,5.638324463165283L5.256207466125488,13.534786463165283C5.256207466125488,13.820696463165284,5.483910466125488,14.052476463165283,5.764797466125488,14.052476463165283C6.045683466125488,14.052476463165283,6.273387466125488,13.820696463165284,6.273387466125488,13.534786463165283Z"
                    fill="currentColor"
                    fill-opacity="1"
                  />
                  <path
                    d="M5.351668966125488,13.953406463165283Q5.522675466125488,14.127476463165284,5.764797466125488,14.127476463165284Q6.006918466125488,14.127476463165284,6.1779254661254885,13.953406463165283Q6.348387466125488,13.779896463165283,6.348387466125488,13.534786463165283L6.348387466125488,5.638324463165283Q6.348387466125488,5.393213463165283,6.1779254661254885,5.219702763165283Q6.006917466125488,5.045636463165283,5.764797466125488,5.045636463165283Q5.522676466125488,5.045636463165283,5.3516687661254885,5.219702763165283Q5.181207466125488,5.393213463165283,5.181207466125488,5.638324463165283L5.181207466125488,13.534786463165283Q5.181207466125488,13.779896463165283,5.351668966125488,13.953406463165283ZM8.925357466125488,13.953406463165283Q9.09636746612549,14.127476463165284,9.338487466125489,14.127476463165284Q9.580607466125489,14.127466463165284,9.751617466125488,13.953406463165283Q9.922077466125488,13.779896463165283,9.922077466125488,13.534786463165283L9.922077466125488,5.638324463165283Q9.922077466125488,5.393212463165283,9.751617466125488,5.219702763165283Q9.580607466125489,5.045636463165283,9.338487466125489,5.045636463165283Q9.09636746612549,5.045636463165283,8.925357466125488,5.219702763165283Q8.754897466125488,5.393213463165283,8.754897466125488,5.638324463165283L8.754897466125488,13.534786463165283Q8.754897466125488,13.779896463165283,8.925357466125488,13.953406463165283ZM6.070923466125488,13.848286463165284Q5.944005466125488,13.977476463165283,5.764797466125488,13.977476463165283Q5.585588466125488,13.977476463165283,5.458670466125488,13.848286463165284Q5.3312074661254885,13.718536463165282,5.3312074661254885,13.534786463165283L5.3312074661254885,5.638324463165283Q5.3312074661254885,5.454568463165283,5.458670466125488,5.3248244631652835Q5.585588466125488,5.195636463165283,5.764797466125488,5.195636463165283Q5.944005466125488,5.195636463165283,6.070923466125488,5.3248244631652835Q6.198386466125489,5.454568463165283,6.198386466125489,5.638324463165283L6.198386466125489,13.534786463165283Q6.198386466125489,13.718536463165282,6.070923466125488,13.848286463165284ZM9.644607466125489,13.848286463165284Q9.517697466125489,13.977476463165283,9.338487466125489,13.977476463165283Q9.159277466125488,13.977476463165283,9.032357466125488,13.848286463165284Q8.904897466125488,13.718546463165284,8.904897466125488,13.534786463165283L8.904897466125488,5.638323463165284Q8.904897466125488,5.454568463165283,9.032357466125488,5.3248244631652835Q9.159277466125488,5.195636463165283,9.338487466125489,5.195636463165283Q9.517697466125489,5.195636463165283,9.644607466125489,5.3248244631652835Q9.772077466125488,5.454567463165283,9.772077466125488,5.638324463165283L9.772077466125488,13.534786463165283Q9.772077466125488,13.718546463165284,9.644607466125489,13.848286463165284Z"
                    fill-rule="evenodd"
                    fill="currentColor"
                    fill-opacity="1"
                  />
                </g>
                <g>
                  <path
                    d="M6.442491171875,1.110331171875L8.714191171875,1.110331171875C8.995081171875,1.110331171875,9.222781171875,0.878550171875,9.222781171875,0.592639171875C9.222781171875,0.306728171875,8.995081171875,0.0749511323786,8.714191171875,0.074951171875L6.442491171875,0.074951171875C6.161601171875,0.0749511323786,5.933901171875,0.306728171875,5.933901171875,0.592639171875C5.933901171875,0.878550171875,6.161601171875,1.110331171875,6.442491171875,1.110331171875ZM14.566351171875,1.911021171875L0.583541171875,1.911021171875C0.302654171875,1.911021171875,0.074951171875,2.142791171875,0.074951171875,2.428701171875C0.074951171875,2.714611171875,0.302654171875,2.946391171875,0.583541171875,2.946391171875L14.566351171875,2.946391171875C14.847251171875,2.946391171875,15.074951171875,2.714611171875,15.074951171875,2.428701171875C15.074951171875,2.142791171875,14.847251171875,1.911021171875,14.566351171875,1.911021171875M13.210151171875,3.912741171875C12.929251171875,3.912741171875,12.701551171875,4.144521171875,12.701551171875,4.430431171875L12.701551171875,15.039551171875L2.448371171875,15.039551171875L2.448371171875,4.430431171875C2.448371171875,4.144521171875,2.220661171875,3.912741171875,1.939781171875,3.912741171875C1.658891171875,3.912741171875,1.431191171875,4.144521171875,1.431191171875,4.430431171875L1.431191171875,15.557251171875C1.431191171875,15.843151171875,1.658891171875,16.074951171875,1.939781171875,16.074951171875L13.210151171875,16.074951171875C13.491051171875,16.074951171875,13.718751171875,15.843151171875,13.718751171875,15.557251171875L13.718751171875,4.430431171875C13.718751171875,4.144521171875,13.491051171875,3.912741171875,13.210151171875,3.912741171875Z"
                    fill="currentColor"
                    fill-opacity="1"
                  />
                  <path
                    d="M6.029361171875,0.174017571875Q5.858901171875,0.347528171875,5.858901171875,0.592639171875Q5.858901171875,0.837749171875,6.029361171875,1.011260171875Q6.200371171875,1.185331171875,6.442491171875,1.185331171875L8.714191171875,1.185331171875Q8.956311171875,1.185331171875,9.127321171875,1.011260171875Q9.297781171875,0.837748171875,9.297781171875,0.592639171875Q9.297781171875,0.347529171875,9.127321171875,0.174017571875Q8.956311171875,-0.000048828124999997224,8.714191171875,-0.000048828124999997224L6.442491171875,-0.000048828124999997224Q6.200371171875,-0.000048828124999997224,6.029361171875,0.174017571875ZM6.136371171875,0.906138171875Q6.008901171875,0.776395171875,6.008901171875,0.592639171875Q6.008901171875,0.408883171875,6.136371171875,0.27913917187500004Q6.263281171875,0.149951171875,6.442491171875,0.149951171875L8.714191171875,0.149951171875Q8.893401171875,0.149951171875,9.020321171875,0.27913917187500004Q9.147781171875,0.408884171875,9.147781171875,0.592639171875Q9.147781171875,0.776394171875,9.020321171875,0.906138171875Q8.893401171875,1.0353271718750001,8.714191171875,1.035326171875L6.442491171875,1.0353271718750001Q6.263281171875,1.0353271718750001,6.136371171875,0.906138171875ZM14.979451171875,2.010081171875Q14.808451171875,1.836021171875,14.566351171875,1.836021171875L0.583540171875,1.836021171875Q0.341419171875,1.836021171875,0.170412471875,2.010081171875Q-0.000048828124999997224,2.183591171875,-0.000048828124999997224,2.428701171875Q-0.000048828124999997224,2.673811171875,0.170412571875,2.847331171875Q0.341420171875,3.021391171875,0.583541171875,3.021391171875L14.566351171875,3.021391171875Q14.808451171875,3.021391171875,14.979451171875,2.847331171875Q15.149951171875,2.673811171875,15.149951171875,2.428701171875Q15.149951171875,2.183601171875,14.979451171875,2.010081171875ZM0.583541171875,1.986021171875L14.566351171875,1.986021171875Q14.745551171875,1.986021171875,14.872451171875,2.115201171875Q14.999951171875,2.244951171875,14.999951171875,2.428701171875Q14.999951171875,2.612461171875,14.872451171875,2.742201171875Q14.745551171875,2.871391171875,14.566351171875,2.871391171875L0.583541171875,2.871391171875Q0.404332171875,2.871391171875,0.277414171875,2.742201171875Q0.149951171875,2.612461171875,0.149951171875,2.428701171875Q0.149951171875,2.244951171875,0.277414171875,2.115201171875Q0.404332171875,1.986021171875,0.583541171875,1.986021171875ZM13.793751171875,15.557251171875L13.793751171875,4.430431171875Q13.793751171875,4.185321171875,13.623251171875,4.011811171874999Q13.452251171875,3.837741171875,13.210151171875,3.837741171875Q12.968051171875,3.837741171875,12.796951171875,4.011811171874999Q12.626551171875,4.185321171875,12.626551171875,4.430431171875L12.626551171875,14.964551171875L2.523371171875,14.964551171875L2.523371171875,4.430431171875Q2.523371171875,4.185321171875,2.352911171875,4.011811171874999Q2.181901171875,3.837741171875,1.939781171875,3.837741171875Q1.697661171875,3.837741171875,1.526651171875,4.011811171874999Q1.356191171875,4.185321171875,1.356191171875,4.430431171875L1.356191171875,15.557251171875Q1.356191171875,15.802351171875,1.526651171875,15.975851171875Q1.697661171875,16.149951171875,1.939781171875,16.149951171875L13.210151171875,16.149951171875Q13.452251171875,16.149951171875,13.623251171875,15.975851171875Q13.793751171875,15.802351171875,13.793751171875,15.557251171875ZM13.516251171875,4.116931171875Q13.643751171875,4.246671171875,13.643751171875,4.430431171875L13.643751171875,15.557251171875Q13.643751171875,15.741051171875,13.516251171875,15.870751171875Q13.389351171875,15.999951171875,13.210151171875,15.999951171875L1.939781171875,15.999951171875Q1.760571171875,15.999951171875,1.633651171875,15.870751171875Q1.506191171875,15.741051171875,1.506191171875,15.557251171875L1.506191171875,4.430431171875Q1.506191171875,4.246671171875,1.633651171875,4.116931171875Q1.760571171875,3.987741171875,1.939781171875,3.987741171875Q2.118991171875,3.987741171875,2.245901171875,4.116931171875Q2.373371171875,4.246671171875,2.373371171875,4.430431171875L2.373371171875,15.114551171875L12.776551171875,15.114551171875L12.776551171875,4.430431171875Q12.776551171875,4.246671171875,12.903951171875,4.116931171875Q13.030951171875,3.987741171875,13.210151171875,3.987741171875Q13.389351171875,3.987741171875,13.516251171875,4.116931171875Z"
                    fill-rule="evenodd"
                    fill="currentColor"
                    fill-opacity="1"
                  />
                </g>
              </g>
            </svg>
          </Tooltip>
        </span>
      ),
    },
  ]);

  useUnmount(() => {
    clearTimeout(timer.current);
  });

  //获取报告模板/图片 列表
  const getReportTypes = () => {
    const list = [
      {
        details: "",
        img: "https://cdd-feature2.touzhiwang.com/files_download/manu_pic/丰富智能的核查规则.png",
        type: "丰富的核查数据源",
      },
      {
        details: "",
        img: "https://cdd-feature2.touzhiwang.com/files_download/manu_pic/核查对象灵活定义.png",
        type: "支持批量、定时核查",
      },
      {
        details: "",
        img: "https://cdd-feature2.touzhiwang.com/files_download/manu_pic/核查结果一目了然.png",
        type: "核查结果一目了然",
      },
      {
        details: "",
        img: "https://cdd-feature2.touzhiwang.com/files_download/manu_pic/一键加入关联方管理.png",
        type: "核查报告一键导入",
      },
    ];
    setReportTypeList(list);
    return;
    Api.getSuspectPic().then((res) => {
      if (res.code === 200) {
        setReportTypeList(res.data || []);
      } else {
        message.error(res.message);
      }
    });
  };

  //获取筛选框枚举
  const getCheckEnums = () => {
    let params = {};
    if (getIsScheduledTasksView()) {
      params.is_cron = 1;
    }
    Api.getCheckEnums(params).then((res) => {
      if (res.code === 200) {
        // setReportTypeList(res.data || []);
        let task_status = res.data?.task_status || {};
        let task_type = res.data?.task_type || {};
        let task_status_list = [];
        let task_type_list = [];
        Object.keys(task_status).forEach((_) => {
          task_status_list.push({
            value: _,
            label: task_status[_],
          });
        });
        Object.keys(task_type).forEach((_) => {
          task_type_list.push({
            value: _,
            label: task_type[_],
          });
        });
        setVerifyTypeOptions(task_type_list);
        setVerifyStatusOptions(task_status_list);
      } else {
        message.error(res.message);
      }
    });
  };

  //获取数据
  const getDataFunc = () => {
    setLoading(true);
    setDataTimeout();
  };

  //定时获取数据
  const setDataTimeout = (progressArr) => {
    let params = {};
    //正常查询
    if (!progressArr) {
      setSelectedRowKeys([]);
      params = {
        page_size: pageSize,
        page: getPageNumber(),
      };
      if (getVerifyStatus()) {
        params.status = getVerifyStatus();
      }
      if (getVerifyType()) {
        params.type = getVerifyType();
      }
      if (getVerifyObject()) {
        params.check_obj = getVerifyObject();
      }
      if (getVerifyTime()[0] && getVerifyTime()[1]) {
        params.start_date = getVerifyTime()[0];
        params.end_date = getVerifyTime()[1];
      }
    } else {
      //查询需要改状态的数据
      params.task_ids = progressArr;
    }
    Api.getCheckList(params)
      .then((res) => {
        if (timer.current) {
          clearTimeout(timer.current);
          timer.current = null;
        }
        let progressList = [];
        if (res.code === 200) {
          if (!progressArr) {
            if ((res.data.data || []).length === 0 && res.data.total > 0) {
              let page = getPageNumber() - 1;
              pageChange(page >= 1 ? page : 1);
              return;
            }
            setData(res.data.data || []);
            setTotal(res.data.total || 0);
            (res.data.data || []).forEach((_) => {
              if ([0, 10, 20].includes(_.status)) {
                progressList.push(_.id);
              }
            });
          } else {
            let list = getData();

            (res.data.data || []).forEach((_) => {
              if ([0, 10, 20].includes(_.status)) {
                progressList.push(_.id);
              }
              let index = list.findIndex((__) => __.id === _.id);
              list[index] = _;
            });
            setData([...list]);
          }
        } else {
          setData([]);
          setTotal(0);
          message.error(res.message);
        }

        if (progressList.length > 0) {
          timer.current = setTimeout(() => {
            setDataTimeout(progressList.join(","));
          }, timerInterval);
        }

        setLoading(false);
      })
      .catch((sea) => {
        setLoading(false);
      });
  };

  //获取第一页数据
  const getOnePageData = () => {
    setPageNumber(1);
    setTimeout(() => {
      if (getIsScheduledTasksView()) {
        getScheduledTaskData();
      } else {
        setDataTimeout();
      }
    }, 100);
  };

  //获取定时任务数据
  const getScheduledTaskData = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    setLoading(true);
    let params = {};
    params = {
      page_size: pageSize,
      page: getPageNumber(),
    };
    if (getVerifyStatus()) {
      params.status = getVerifyStatus();
    }
    if (getVerifyType()) {
      params.type = getVerifyType();
    }
    if (getVerifyObject()) {
      params.check_obj = getVerifyObject();
    }
    if (getVerifyTime()[0] && getVerifyTime()[1]) {
      params.start_date = getVerifyTime()[0];
      params.end_date = getVerifyTime()[1];
    }
    Api.getCronCheckList(params)
      .then((res) => {
        if (res.code === 200) {
          if ((res.data.data || []).length === 0 && res.data.total > 0) {
            let page = getPageNumber() - 1;
            pageChange(page >= 1 ? page : 1);
            return;
          }
          setData(res.data.data || []);
          setTotal(res.data.total || 0);
        } else {
          setData([]);
          setTotal(0);
          message.error(res.message);
        }
        setLoading(false);
      })
      .catch((sea) => {
        setLoading(false);
      });
  };

  //核查状态变化
  const verifyStatusHandleChange = (value) => {
    setVerifyStatus(value);
    getOnePageData();
  };

  //核查类型变化
  const verifyTypeHandleChange = (value) => {
    setVerifyType(value);
    getOnePageData();
  };

  //核查时间变化
  const verifyTimeHandleChange = (date, dateString) => {
    setVerifyTime(dateString);
    getOnePageData();
  };

  //核查对象变化
  const verifyObjectHandleChange = (value) => {
    setVerifyObject(value);
  };

  useEffect(() => {
    if (debouncedVerifyObject === null) {
      return;
    }
    getOnePageData();
  }, [debouncedVerifyObject]);

  //页码变化
  const pageChange = (page) => {
    setPageNumber(page);
    setTimeout(() => {
      if (getIsScheduledTasksView()) {
        getScheduledTaskData();
      } else {
        setDataTimeout();
      }
    }, 100);
  };

  //排列顺序改变
  const orderChange = async (e, key, orderChange) => {
    if (orderField === key) {
      const asc = await getOrderAsc();
      await setOrderAsc(asc === 1 ? -1 : 1);
    } else {
      await setOrderField(key);
      await setOrderAsc(orderChange);
    }
    setTimeout(() => {
      getOnePageData();
    }, 100);
  };

  //添加核查函数
  const addVerificationFunc = (isScheduledTask) => {
    setVerifySetting(null);
    //isScheduledTask 是否是创建定时任务
    setIsScheduledTask(!!isScheduledTask);
    setCreateDrawerOpen(true);
  };

  //创建成功回调
  const createSuccessFunc = () => {
    setVerifySetting(null);
    getOnePageData();
    setCreateDrawerOpen(false);
  };

  //表格选择 改变
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  useEffect(() => {
    getDataFunc();
    // getReportTypes();
    getCheckEnums();
  }, []);

  return (
    <div className="intelligentVerification" ref={contentRef}>
      {!isScheduledTasksView ? (
        <div class="headerTitleContent">
          <div class="left">
            <span class="block"></span>
            <div class="title">
              <div class="commentsHeaderTitleBox">主体核查</div>
            </div>
          </div>
          <div class="right"> </div>
        </div>
      ) : (
        <span
          className="backSpan"
          onClick={() => {
            setIsScheduledTasksView(false);
            setTimeout(() => {
              getCheckEnums();
            }, 20);
            setLoading(true);
            getOnePageData();
          }}
        >
          <LeftOutlined /> 返回
        </span>
      )}
      <div className="content">
        <div className={!isScheduledTasksView ? "btnBox" : "btnBox btnBox2"}>
          {!isScheduledTasksView ? (
            <div
              className="createBtnBox"
              onClick={() => {
                // getLicenseValid().then((res) => {
                //   if (res) {
                //     addVerificationFunc();
                //   }
                // });
                addVerificationFunc();
              }}
            >
              <div className="btnContent">
                <ReactSVG className="wordIcon" src={startIcon}></ReactSVG>
                开始核查
              </div>
              <div className="btnIcon">
                <PlusOutlined />
              </div>
            </div>
          ) : (
            <span className="btnSpan">智能核查-定时任务</span>
          )}

          <div
            className="createBtnBox"
            onClick={() => {
              // getLicenseValid().then((res) => {
              //   if (res) {
              //     addVerificationFunc();
              //   }
              // });
              addVerificationFunc(true);
            }}
          >
            <div className="btnContent">
              <ReactSVG className="wordIcon" src={timingIcon}></ReactSVG>
              创建定时任务
            </div>
            <div className="btnIcon">
              <PlusOutlined />
            </div>
          </div>
        </div>

        <div className="infoContent">
          {/* {!isScheduledTasksView && (
            <div
              className="orderTitle"
              style={{
                marginTop: "8px",
              }}
            >
              <ReactSVG className="icon" src={icon1}></ReactSVG>功能简介
            </div>
          )} */}
          {/* 报告模板介绍 */}
          {/* {!isScheduledTasksView && (
            <div className="introduceBox" ref={carouselRef2}>
              <div style={{ display: "block", height: "100%", width: "100%" }}>
                <Slider
                  dots={true}
                  infinite={false}
                  speed={500}
                  slidesToShow={4}
                  slidesToScroll={1}
                  // autoplay={true}
                  // autoplaySpeed={5000}
                  ref={carouselRef}
                  beforeChange={(current, next) => {
                    setNotHasPrev(next === 0);
                    setNotHasNext(next + 4 === reportTypeList?.length);
                  }}
                >
                  {reportTypeList.map((item, _index) => (
                    <Tooltip
                      key={_index}
                      title={item.details}
                      arrowPointAtCenter
                    >
                      <div
                        key={_index}
                        className="introduceReportBox"
                        style={{ backgroundColor: bgColor[_index % 4] }}
                      >
                        <div className="introduceReportItem">
                          <div className="reportType">{item.type}</div>
                          <div className="reportContent">
                            <Image
                              width={"100%"}
                              style={{
                                display: "block",
                              }}
                              src={item.img}
                            />
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  ))}
                </Slider>
              </div>

              {reportTypeList?.length > 4 && !notHasPrev && (
                <LeftOutlined
                  className="carouselIcon LeftOutlined"
                  onClick={() => carouselRef.current?.slickPrev()}
                />
              )}

              {reportTypeList?.length > 4 && !notHasNext && (
                <RightOutlined
                  className="carouselIcon RightOutlined"
                  onClick={() => carouselRef.current?.slickNext()}
                />
              )}
            </div>
          )} */}
          {/* 全部报告标题 */}
          {!isScheduledTasksView && (
            <div className="orderTitle">
              <ReactSVG className="icon" src={icon1}></ReactSVG>核查记录
              <div
                className="float-right"
                onClick={() => {
                  setIsScheduledTasksView(true);
                  setTimeout(() => {
                    getCheckEnums();
                  }, 20);
                  getOnePageData();
                }}
              >
                <ReactSVG className="icon" src={timingIcon}></ReactSVG>
                查看定时任务
              </div>
            </div>
          )}
          <div className="inputsBox">
            <div className="inputItemBox">
              {isScheduledTasksView ? "任务" : "核查"}状态
              <Select
                style={{ width: 150, marginLeft: "12px" }}
                onChange={verifyStatusHandleChange}
                value={verifyStatus}
                placeholder={`请选择${
                  isScheduledTasksView ? "任务" : "核查"
                }状态`}
                allowClear
                options={verifyStatusOptions}
              />
            </div>
            <div className="inputItemBox">
              {isScheduledTasksView ? "任务" : "核查"}类型
              <Select
                style={{ width: 150, marginLeft: "12px" }}
                onChange={verifyTypeHandleChange}
                value={verifyType}
                placeholder={`请选择${
                  isScheduledTasksView ? "任务" : "核查"
                }类型`}
                allowClear
                options={verifyTypeOptions}
              />
            </div>
            <div className="inputItemBox">
              {isScheduledTasksView ? "创建" : "核查"}时间
              <RangePicker
                style={{ width: 240, marginLeft: "12px" }}
                allowClear
                format="YYYY-MM-DD"
                value={verifyTime?.map((_) =>
                  _ ? dayjs(_, "YYYY-MM-DD") : null,
                )}
                onChange={verifyTimeHandleChange}
              />
            </div>
            <div className="inputItemBox">
              核查对象
              <Input
                placeholder="请输入核查对象"
                style={{ width: 150, marginLeft: "12px" }}
                onChange={(e) => {
                  verifyObjectHandleChange(e.target.value);
                }}
                value={verifyObject}
                allowClear
              />
            </div>
          </div>
          <div className="sortBox">
            {/* {!isScheduledTasksView ? (
              <span className="filterItem">
                {[
                  {
                    label: "最近核查",
                    key: "create_time",
                    width: "80px",
                    defaultAsc: -1,
                  },
                  {
                    label: "核查对象",
                    key: "project_name",
                    width: "80px",
                    defaultAsc: 1,
                  },
                  {
                    label: "发现关注项",
                    key: "company_name",
                    width: "110px",
                    defaultAsc: 1,
                  },
                ].map((item) => (
                  <span
                    key={item.key}
                    className="optionItem"
                    onClick={debounce(
                      orderChange,
                      200,
                      item.key,
                      item.defaultAsc || 1
                    )}
                    style={{
                      color: orderField === item.key ? "#0068b2" : "#535353",
                      width: item.width,
                    }}
                  >
                    {item.label}
                    {orderField === item.key &&
                      (orderAsc === 1 ? (
                        <CaretUpOutlined />
                      ) : (
                        <CaretDownOutlined />
                      ))}
                  </span>
                ))}
              </span>
            ) : (
              <span></span>
            )} */}
            <span></span>
            <div className="iconItemsBox">
              {/* {!isScheduledTasksView && (
                <Tooltip title="下载">
                  <VerticalAlignBottomOutlined />
                </Tooltip>
              )} */}
              <Tooltip title="批量删除">
                <svg
                  className="tableIcon"
                  fill="none"
                  version="1.1"
                  width="15.14990234375"
                  height="16.14990234375"
                  viewBox="0 0 15.14990234375 16.14990234375"
                  onClick={(e) => {
                    e.stopPropagation();
                    MessageModal({
                      type: "warning",
                      description: "确定要删除选中的数据吗？",
                      title: "批量删除",
                      onOk: () => {
                        deleteFunc();
                      },
                    });
                  }}
                >
                  <g>
                    <g>
                      <path
                        d="M9.847077466125487,13.534786463165283L9.847077466125487,5.638324463165283C9.847077466125487,5.352412463165283,9.619367466125489,5.120636463165283,9.338487466125489,5.120636463165283C9.057597466125488,5.120636463165283,8.829897466125487,5.352412463165283,8.829897466125487,5.638324463165283L8.829897466125487,13.534786463165283C8.829897466125487,13.820696463165284,9.057597466125488,14.052476463165283,9.338487466125489,14.052476463165283C9.619367466125489,14.052476463165283,9.847077466125487,13.820696463165284,9.847077466125487,13.534786463165283ZM6.273387466125488,13.534786463165283L6.273387466125488,5.638324463165283C6.273387466125488,5.352412463165283,6.045683466125488,5.120636463165283,5.764797466125488,5.120636463165283C5.483910466125488,5.120636463165283,5.256207466125488,5.352412463165283,5.256207466125488,5.638324463165283L5.256207466125488,13.534786463165283C5.256207466125488,13.820696463165284,5.483910466125488,14.052476463165283,5.764797466125488,14.052476463165283C6.045683466125488,14.052476463165283,6.273387466125488,13.820696463165284,6.273387466125488,13.534786463165283Z"
                        fill="currentColor"
                        fill-opacity="1"
                      />
                      <path
                        d="M5.351668966125488,13.953406463165283Q5.522675466125488,14.127476463165284,5.764797466125488,14.127476463165284Q6.006918466125488,14.127476463165284,6.1779254661254885,13.953406463165283Q6.348387466125488,13.779896463165283,6.348387466125488,13.534786463165283L6.348387466125488,5.638324463165283Q6.348387466125488,5.393213463165283,6.1779254661254885,5.219702763165283Q6.006917466125488,5.045636463165283,5.764797466125488,5.045636463165283Q5.522676466125488,5.045636463165283,5.3516687661254885,5.219702763165283Q5.181207466125488,5.393213463165283,5.181207466125488,5.638324463165283L5.181207466125488,13.534786463165283Q5.181207466125488,13.779896463165283,5.351668966125488,13.953406463165283ZM8.925357466125488,13.953406463165283Q9.09636746612549,14.127476463165284,9.338487466125489,14.127476463165284Q9.580607466125489,14.127466463165284,9.751617466125488,13.953406463165283Q9.922077466125488,13.779896463165283,9.922077466125488,13.534786463165283L9.922077466125488,5.638324463165283Q9.922077466125488,5.393212463165283,9.751617466125488,5.219702763165283Q9.580607466125489,5.045636463165283,9.338487466125489,5.045636463165283Q9.09636746612549,5.045636463165283,8.925357466125488,5.219702763165283Q8.754897466125488,5.393213463165283,8.754897466125488,5.638324463165283L8.754897466125488,13.534786463165283Q8.754897466125488,13.779896463165283,8.925357466125488,13.953406463165283ZM6.070923466125488,13.848286463165284Q5.944005466125488,13.977476463165283,5.764797466125488,13.977476463165283Q5.585588466125488,13.977476463165283,5.458670466125488,13.848286463165284Q5.3312074661254885,13.718536463165282,5.3312074661254885,13.534786463165283L5.3312074661254885,5.638324463165283Q5.3312074661254885,5.454568463165283,5.458670466125488,5.3248244631652835Q5.585588466125488,5.195636463165283,5.764797466125488,5.195636463165283Q5.944005466125488,5.195636463165283,6.070923466125488,5.3248244631652835Q6.198386466125489,5.454568463165283,6.198386466125489,5.638324463165283L6.198386466125489,13.534786463165283Q6.198386466125489,13.718536463165282,6.070923466125488,13.848286463165284ZM9.644607466125489,13.848286463165284Q9.517697466125489,13.977476463165283,9.338487466125489,13.977476463165283Q9.159277466125488,13.977476463165283,9.032357466125488,13.848286463165284Q8.904897466125488,13.718546463165284,8.904897466125488,13.534786463165283L8.904897466125488,5.638323463165284Q8.904897466125488,5.454568463165283,9.032357466125488,5.3248244631652835Q9.159277466125488,5.195636463165283,9.338487466125489,5.195636463165283Q9.517697466125489,5.195636463165283,9.644607466125489,5.3248244631652835Q9.772077466125488,5.454567463165283,9.772077466125488,5.638324463165283L9.772077466125488,13.534786463165283Q9.772077466125488,13.718546463165284,9.644607466125489,13.848286463165284Z"
                        fill-rule="evenodd"
                        fill="currentColor"
                        fill-opacity="1"
                      />
                    </g>
                    <g>
                      <path
                        d="M6.442491171875,1.110331171875L8.714191171875,1.110331171875C8.995081171875,1.110331171875,9.222781171875,0.878550171875,9.222781171875,0.592639171875C9.222781171875,0.306728171875,8.995081171875,0.0749511323786,8.714191171875,0.074951171875L6.442491171875,0.074951171875C6.161601171875,0.0749511323786,5.933901171875,0.306728171875,5.933901171875,0.592639171875C5.933901171875,0.878550171875,6.161601171875,1.110331171875,6.442491171875,1.110331171875ZM14.566351171875,1.911021171875L0.583541171875,1.911021171875C0.302654171875,1.911021171875,0.074951171875,2.142791171875,0.074951171875,2.428701171875C0.074951171875,2.714611171875,0.302654171875,2.946391171875,0.583541171875,2.946391171875L14.566351171875,2.946391171875C14.847251171875,2.946391171875,15.074951171875,2.714611171875,15.074951171875,2.428701171875C15.074951171875,2.142791171875,14.847251171875,1.911021171875,14.566351171875,1.911021171875M13.210151171875,3.912741171875C12.929251171875,3.912741171875,12.701551171875,4.144521171875,12.701551171875,4.430431171875L12.701551171875,15.039551171875L2.448371171875,15.039551171875L2.448371171875,4.430431171875C2.448371171875,4.144521171875,2.220661171875,3.912741171875,1.939781171875,3.912741171875C1.658891171875,3.912741171875,1.431191171875,4.144521171875,1.431191171875,4.430431171875L1.431191171875,15.557251171875C1.431191171875,15.843151171875,1.658891171875,16.074951171875,1.939781171875,16.074951171875L13.210151171875,16.074951171875C13.491051171875,16.074951171875,13.718751171875,15.843151171875,13.718751171875,15.557251171875L13.718751171875,4.430431171875C13.718751171875,4.144521171875,13.491051171875,3.912741171875,13.210151171875,3.912741171875Z"
                        fill="currentColor"
                        fill-opacity="1"
                      />
                      <path
                        d="M6.029361171875,0.174017571875Q5.858901171875,0.347528171875,5.858901171875,0.592639171875Q5.858901171875,0.837749171875,6.029361171875,1.011260171875Q6.200371171875,1.185331171875,6.442491171875,1.185331171875L8.714191171875,1.185331171875Q8.956311171875,1.185331171875,9.127321171875,1.011260171875Q9.297781171875,0.837748171875,9.297781171875,0.592639171875Q9.297781171875,0.347529171875,9.127321171875,0.174017571875Q8.956311171875,-0.000048828124999997224,8.714191171875,-0.000048828124999997224L6.442491171875,-0.000048828124999997224Q6.200371171875,-0.000048828124999997224,6.029361171875,0.174017571875ZM6.136371171875,0.906138171875Q6.008901171875,0.776395171875,6.008901171875,0.592639171875Q6.008901171875,0.408883171875,6.136371171875,0.27913917187500004Q6.263281171875,0.149951171875,6.442491171875,0.149951171875L8.714191171875,0.149951171875Q8.893401171875,0.149951171875,9.020321171875,0.27913917187500004Q9.147781171875,0.408884171875,9.147781171875,0.592639171875Q9.147781171875,0.776394171875,9.020321171875,0.906138171875Q8.893401171875,1.0353271718750001,8.714191171875,1.035326171875L6.442491171875,1.0353271718750001Q6.263281171875,1.0353271718750001,6.136371171875,0.906138171875ZM14.979451171875,2.010081171875Q14.808451171875,1.836021171875,14.566351171875,1.836021171875L0.583540171875,1.836021171875Q0.341419171875,1.836021171875,0.170412471875,2.010081171875Q-0.000048828124999997224,2.183591171875,-0.000048828124999997224,2.428701171875Q-0.000048828124999997224,2.673811171875,0.170412571875,2.847331171875Q0.341420171875,3.021391171875,0.583541171875,3.021391171875L14.566351171875,3.021391171875Q14.808451171875,3.021391171875,14.979451171875,2.847331171875Q15.149951171875,2.673811171875,15.149951171875,2.428701171875Q15.149951171875,2.183601171875,14.979451171875,2.010081171875ZM0.583541171875,1.986021171875L14.566351171875,1.986021171875Q14.745551171875,1.986021171875,14.872451171875,2.115201171875Q14.999951171875,2.244951171875,14.999951171875,2.428701171875Q14.999951171875,2.612461171875,14.872451171875,2.742201171875Q14.745551171875,2.871391171875,14.566351171875,2.871391171875L0.583541171875,2.871391171875Q0.404332171875,2.871391171875,0.277414171875,2.742201171875Q0.149951171875,2.612461171875,0.149951171875,2.428701171875Q0.149951171875,2.244951171875,0.277414171875,2.115201171875Q0.404332171875,1.986021171875,0.583541171875,1.986021171875ZM13.793751171875,15.557251171875L13.793751171875,4.430431171875Q13.793751171875,4.185321171875,13.623251171875,4.011811171874999Q13.452251171875,3.837741171875,13.210151171875,3.837741171875Q12.968051171875,3.837741171875,12.796951171875,4.011811171874999Q12.626551171875,4.185321171875,12.626551171875,4.430431171875L12.626551171875,14.964551171875L2.523371171875,14.964551171875L2.523371171875,4.430431171875Q2.523371171875,4.185321171875,2.352911171875,4.011811171874999Q2.181901171875,3.837741171875,1.939781171875,3.837741171875Q1.697661171875,3.837741171875,1.526651171875,4.011811171874999Q1.356191171875,4.185321171875,1.356191171875,4.430431171875L1.356191171875,15.557251171875Q1.356191171875,15.802351171875,1.526651171875,15.975851171875Q1.697661171875,16.149951171875,1.939781171875,16.149951171875L13.210151171875,16.149951171875Q13.452251171875,16.149951171875,13.623251171875,15.975851171875Q13.793751171875,15.802351171875,13.793751171875,15.557251171875ZM13.516251171875,4.116931171875Q13.643751171875,4.246671171875,13.643751171875,4.430431171875L13.643751171875,15.557251171875Q13.643751171875,15.741051171875,13.516251171875,15.870751171875Q13.389351171875,15.999951171875,13.210151171875,15.999951171875L1.939781171875,15.999951171875Q1.760571171875,15.999951171875,1.633651171875,15.870751171875Q1.506191171875,15.741051171875,1.506191171875,15.557251171875L1.506191171875,4.430431171875Q1.506191171875,4.246671171875,1.633651171875,4.116931171875Q1.760571171875,3.987741171875,1.939781171875,3.987741171875Q2.118991171875,3.987741171875,2.245901171875,4.116931171875Q2.373371171875,4.246671171875,2.373371171875,4.430431171875L2.373371171875,15.114551171875L12.776551171875,15.114551171875L12.776551171875,4.430431171875Q12.776551171875,4.246671171875,12.903951171875,4.116931171875Q13.030951171875,3.987741171875,13.210151171875,3.987741171875Q13.389351171875,3.987741171875,13.516251171875,4.116931171875Z"
                        fill-rule="evenodd"
                        fill="currentColor"
                        fill-opacity="1"
                      />
                    </g>
                  </g>
                </svg>
              </Tooltip>
            </div>
          </div>
          <div className="tableContainer">
            <Table
              className="myFormTable"
              locale={{
                emptyText: (
                  <Empty image={emptyImg} description="暂无数据"></Empty>
                ),
              }}
              loading={loading}
              bordered={true}
              pagination={false}
              rowSelection={{
                selectedRowKeys,
                onChange: onSelectChange,
              }}
              scroll={{
                y:
                  (size?.height || 0) -
                  ((isScheduledTasksView ? 270 : 340) + (total > 10 ? 40 : 0)),
              }}
              onRow={(record) => {
                return {
                  onClick: (event) => {
                    verificationTaskHandle("查看", record);
                  }, // 点击行
                };
              }}
              rowKey="id"
              columns={
                isScheduledTasksView ? columns2.current : columns.current
              }
              dataSource={data}
            />
            {total > 10 && (
              <div className="paginationBox">
                <Pagination
                  onChange={pageChange}
                  className="myPagination"
                  pageSize={pageSize}
                  current={pageNumber}
                  total={total}
                  showTotal={(total) => `共 ${total} 条`}
                  showSizeChanger={false}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <CreateDrawer
        open={createDrawerOpen}
        defaultSetting={verifySetting}
        onClose={() => {
          setCreateDrawerOpen(false);
          setVerifySetting(null);
        }}
        isScheduledTask={isScheduledTask}
        successFunc={createSuccessFunc}
      ></CreateDrawer>
    </div>
  );
}
export default Home;
